import styled, { CSSObject } from '@emotion/styled'
import { keyframes } from '@emotion/react'
import { cssSetColorOpacity } from 'shop/theme/helpers'

interface ThreeDotsLoaderProps {
  size?: number
  color?: string
}

const ThreeDotsLoader: React.FC<ThreeDotsLoaderProps> = ({ size, color }) => {
  return (
    <DotsContainer>
      <Dot size={size} color={color} animationDelay={'0s'} />
      <Dot size={size} color={color} animationDelay={'0.2s'} />
      <Dot size={size} color={color} animationDelay={'0.4s'} />
    </DotsContainer>
  )
}

const bounce = keyframes`
  0%, 80%, 100% {
    transform: scale(0);
    opacity: 0.3;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
`

const DotsContainer = styled.div(
  (): CSSObject => ({
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%'
  })
)

const Dot = styled.span<{
  size?: number
  color?: string
  animationDelay: string
}>(
  ({ theme, size = 12, color, animationDelay }): CSSObject => ({
    width: size,
    height: size,
    backgroundColor: color
      ? color
      : cssSetColorOpacity(theme.colors.primary, 80),
    borderRadius: '50%',
    animation: `${bounce} 1.4s infinite ease-in-out both`,
    animationDelay: animationDelay
  })
)

export default ThreeDotsLoader
